
import { Component } from "vue-property-decorator";
import SelectFieldController from "../ts/SelectFieldController";

declare var M: any;
declare var $: any;

@Component({
  props: {
    selectId: String,
    multiple: String,
    onOptionChange: Function,
    required: String,
    name: String,
  },
})
export default class SelectField extends SelectFieldController {
  mounted() {
    SelectFieldController.refresh();
    if (this.$props.change) {
      const self = this;
      $("#" + this.$props.selectId).on("change", function (e: any) {
        self.$props.change(e);
      });
    }
  }
}
